import type { AcquisitionPopupContainerProps } from "@product/scmp-sdk";
import { AcquisitionPopupContainer } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { config } from "shared/data";
import { accountAtom } from "shared/lib/account/atoms";

type Props = {
  skipTriggerFromConfig?: AcquisitionPopupContainerProps["skipTriggerFromConfig"];
};

export const AcquisitionPopupContainerWrapper: FunctionComponent<Props> = ({
  skipTriggerFromConfig,
}) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  // for the 'environment':
  // - production: the live production environment
  // - development: all other non-production environment
  // 'isAcceptedGDPR' control the show / hide when user not yet accept GDPR

  return (
    <AcquisitionPopupContainer
      configEnvironmentSlug={config.general.env === "production" ? "production" : "dev"}
      isLoggedIn={isLoggedIn}
      skipTriggerFromConfig={skipTriggerFromConfig}
    />
  );
};

AcquisitionPopupContainerWrapper.displayName = "AcquisitionPopupContainerWrapper";
